import { CognitoIdentityClient, GetIdCommand, GetOpenIdTokenCommand } from "@aws-sdk/client-cognito-identity";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { selectOidcUserData } from "@org-avp/avp-avengers-ui-shared-store";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

// token is valid 10 minutes
const nineMinutesInMs = 9 * 60 * 1000;
const IdentityPoolId = environment.NX_IDENTITY_POOL_ID;
const userPoolLogin = environment.NX_OIDC_AUTHORITY.replace("https://", "");
const cognitoIdentityClient = new CognitoIdentityClient({
  region: IdentityPoolId.split(":")[0],
});

export const useCognitoIdToken = (): string | null => {
  const { idToken: oidcIdToken } = useSelector(selectOidcUserData);
  const [cognitoIdToken, setCognitoIdToken] = useState<string | null>(null);
  const fetchAndSetCognitoIdToken = useCallback(
    (oidcIdToken: string) => {
      fetchCognitoIdTokenWithSdk(oidcIdToken)
        .catch(() => null) // delete previous value on error
        .then((it) => setCognitoIdToken(it));
    },
    [],
  );

  useEffect(
    () => {
      fetchAndSetCognitoIdToken(oidcIdToken);
      const intervalId = setInterval(
        () => fetchAndSetCognitoIdToken(oidcIdToken),
        nineMinutesInMs,
      );

      return () => clearInterval(intervalId);
    },
    [fetchAndSetCognitoIdToken, oidcIdToken],
  );

  return cognitoIdToken;
};

const fetchCognitoIdTokenWithSdk = async (idToken: string): Promise<string | null> => {
  const Logins = { [userPoolLogin]: idToken };
  const { IdentityId } = await cognitoIdentityClient.send(
    new GetIdCommand({ IdentityPoolId, Logins }),
  );
  const { Token } = await cognitoIdentityClient.send(
    new GetOpenIdTokenCommand({ IdentityId, Logins }),
  );

  return Token ?? null;
};
